/**
 * Returns true if the given notification is unread.
 *
 * @param {object} notification The notification object to check.
 * @returns {boolean} Returns true if the notification is unread, false otherwise.
 */
export function isNotificationUnread(notification) {
    return !notification.read;
}
